var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useMemo } from 'react';
import { Label } from '@ally/metronome-ui';
import { SingleDatePicker } from '@ally/forms';
import { withProps } from '@ally/validator';
import validator from './validator';
import { useComputedValues } from '../../useComputedValues';
import { getDatePickerProps, getMinDeliveryDate } from '../../utils';
import { TransferSpeedsContext } from '../../useTransferSpeeds';
import { useHolidays } from '../../useHolidays';
import { isLoading } from '../../Remote';
import { DELIVERY_DATE_ADVANCE_DAYS } from '../../constants';
var DeliveryDateInput = function () {
    var _a = useContext(TransferSpeedsContext), transferSpeeds = _a.transferSpeeds, withdrawalDate = _a.withdrawalDate;
    var _b = useComputedValues(), transferType = _b.transferType, frequency = _b.frequency, disableForm = _b.disableForm;
    var minDeliveryDate = useMemo(function () {
        return getMinDeliveryDate({
            frequency: frequency,
            transferSpeeds: transferSpeeds,
            transferType: transferType,
        });
    }, [frequency, transferSpeeds, transferType]);
    var holidays = useHolidays();
    var validate = useMemo(function () {
        return withProps(validator, {
            frequency: frequency,
            holidays: holidays,
            minDeliveryDate: minDeliveryDate,
            maxAdvanceDuration: [DELIVERY_DATE_ADVANCE_DAYS, 'days'],
            transferType: transferType,
        });
    }, [frequency, holidays, minDeliveryDate, transferType]);
    var datePickerProps = useMemo(function () {
        return getDatePickerProps({
            holidays: holidays,
            minDate: minDeliveryDate,
            transferType: transferType,
            maxAdvanceDuration: [DELIVERY_DATE_ADVANCE_DAYS, 'days'],
            frequency: frequency,
        });
    }, [holidays, minDeliveryDate, transferType, frequency]);
    var shouldDisable = isLoading([transferSpeeds, withdrawalDate]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Label, { htmlFor: "deliveryDate" }, "Deliver on"),
        React.createElement(SingleDatePicker, __assign({ name: "deliveryDate", ariaLabel: "Deliver On", validate: validate, disabled: shouldDisable || disableForm }, datePickerProps))));
};
export default DeliveryDateInput;
//# sourceMappingURL=Input.js.map